import { Antecedentes_edif } from './../../../models/antecedentes_edif.model';
import { Component, ViewChild, TemplateRef, DoCheck } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-antecedentes_edif",
    templateUrl: "./antecedentes_edif.component.html",
    styleUrls: ["./antecedentes_edif.component.css"],
    providers: [FormService]
})
export class Antecedentes_edifComponent implements DoCheck {
    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public antecedentes_edif: Antecedentes_edif;
    public form;
    public temp_ant;



    public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog) {

        this.form = new FormGroup({
            edificacion_antigua: new FormControl(''),
            ampliacion_antigua: new FormControl(''),
            destino: new FormControl(''),
            superf_total: new FormControl(''),
            superf_terreno: new FormControl(''),
            npisos: new FormControl('')
        })


        if (!JSON.parse(localStorage.getItem("antecedentes_edif"))) {
            localStorage.setItem("antecedentes_edif", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("antecedentes_edif"));
            // this.form.controls['edificacion_antigua'].setValue(this.rows[0] ? this.rows[0].edificacion_antigua : '');
            // this.form.controls['ampliacion_antigua'].setValue(this.rows[0] ? this.rows[0].ampliacion_antigua : '');
            // this.form.controls['destino'].setValue(this.rows[0] ? this.rows[0].destino : '');
            // this.form.controls['superf_total'].setValue(this.rows[0] ? this.rows[0].superf_total : '');
            // this.form.controls['superf_terreno'].setValue(this.rows[0] ? this.rows[0].superf_terreno : '')
            // this.form.controls['npisos'].setValue(this.rows[0] ? this.rows[0].npisos : '')
        }
        this.antecedentes_edif = { edificacion_antigua: '', ampliacion_antigua: '', destino: '', superf_total: 0, superf_terreno: 0, npisos: 0 };
        this.temp_ant = { edificacion_antigua: '', ampliacion_antigua: '', destino: '', superf_total: 0, superf_terreno: 0, npisos: 0 };

    }


    ngDoCheck() {

    }


    add_antecedentes_edif() {
        localStorage.setItem("caract_anteproyecto", JSON.stringify([]));
        this.actualRow = localStorage.getItem("antecedentes_edif");

        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.edificacion_antigua && !this.form.value.ampliacion_antigua && !this.form.value.destino && !this.form.value.superf_total && !this.form.superf_terreno && !this.form.value.npisos) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);
        } else {
            this.rows = this.rows.concat({
                edificacion_antigua: this.form.value.edificacion_antigua,
                ampliacion_antigua: this.form.value.ampliacion_antigua,
                destino: this.form.value.destino,
                superf_total: this.form.value.superf_total,
                superf_terreno: this.form.value.superf_terreno,
                npisos: this.form.value.npisos
            })
            localStorage.setItem("antecedentes_edif", JSON.stringify(this.rows));
            this.form.reset();
        }


    }
    delete_antecedentes_edif(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes_edif", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("antecedentes_edif");
        this.rows = JSON.parse(this.actualRow);
    }



    get_antecedentes_edif(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_ant.id = id;
                this.temp_ant.edificacion_antigua = this.rows[x].edificacion_antigua;
                this.temp_ant.ampliacion_antigua = this.rows[x].ampliacion_antigua;
                this.temp_ant.destino = this.rows[x].destino;
                this.temp_ant.superf_total = this.rows[x].superf_total;
                this.temp_ant.superf_terreno = this.rows[x].superf_terreno;
                this.temp_ant.npisos = this.rows[x].npisos;

                console.log(this.temp_ant);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_ant = { edificacion_antigua: '', ampliacion_antigua: '', destino: '', superf_total: 0, superf_terreno: 0, npisos: 0 };

    }

    saveAntecedentes_edif() {
        var id = this.temp_ant.id;
        console.log(this.temp_ant)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("antecedentes_edif", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("antecedentes_edif");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    edificacion_antigua: this.temp_ant.edificacion_antigua,
                    ampliacion_antigua: this.temp_ant.ampliacion_antigua,
                    destino: this.temp_ant.destino,
                    superf_total: this.temp_ant.superf_total,
                    superf_terreno: this.temp_ant.superf_terreno,
                    npisos: this.temp_ant.npisos
                })
                localStorage.setItem("antecedentes_edif", JSON.stringify(this.rows));
                this.temp_ant = [];
                this.dialog.closeAll();
            }
        }
    }

}